import type { IMBOImageUrl } from '@vgtv/api-client';
import type { TagEnrichment } from '@vgtv/api-client/lib/cnp_tag';

function getTagBackgroundImage(
  tag: Pick<TagEnrichment, 'images'>
): IMBOImageUrl | undefined {
  return tag.images ? tag.images.background : undefined;
}

function getTagMainImage(
  tag: Pick<TagEnrichment, 'images'>
): IMBOImageUrl | undefined {
  return tag.images ? tag.images.main : undefined;
}

export { getTagBackgroundImage, getTagMainImage };
